import './rotating-cube3.css';
import bioAiIcon from '../../images/Cube/bio-ai.svg';
import longevityIcon from '../../images/Cube/longevity.svg';
import nutritionIcon from '../../images/Cube/nutrition.svg';
import preventionIcon from '../../images/Cube/prevention.svg';
import doctorsIcon from '../../images/Cube/doctors.svg';
import sportsIcon from '../../images/Cube/sports.svg';

const CUBE_FACES = [
  { className: 'front', icon: bioAiIcon, label: 'Bio ai', labelIcon: bioAiIcon },
  { className: 'back', icon: longevityIcon, label: 'Longevity', labelIcon: longevityIcon },
  { className: 'right', icon: nutritionIcon, label: 'Nutrition', labelIcon: nutritionIcon },
  { className: 'left', icon: preventionIcon, label: 'prevention', labelIcon: preventionIcon },
  { className: 'top', icon: doctorsIcon, label: 'Longevity', labelIcon: longevityIcon },
  { className: 'bottom', icon: sportsIcon, label: 'Age reversal', labelIcon: null },
];

/**
 * Dedicated cube for SplashScreen3.
 * Keep changes here isolated from SplashScreen4's `RotatingCube`.
 */
export default function RotatingCube3({ variant = 'icons', showLabelIcons = true }) {
  const useLabels = variant === 'labels';

  return (
    <div className="parent-container">
      <div className="beam-outer" aria-hidden />
      <div className="beam-inner" aria-hidden />
      <div className="beam-ring" aria-hidden />

      <div className="cube-container">
        {CUBE_FACES.map(({ className, icon, label, labelIcon }) => (
          <div key={className} className={`cube-face ${className}`}>
            <div className="icon-circle">
              {useLabels ? (
                <div className="cube-face-label-stack">
                  {showLabelIcons ? (
                    labelIcon ? (
                      <img
                        src={labelIcon}
                        alt=""
                        className="cube-face-label-icon"
                        width={56}
                        height={56}
                        decoding="async"
                      />
                    ) : (
                      <span className="cube-face-label-icon-spacer" aria-hidden />
                    )
                  ) : null}
                  {label ? <span className="cube-face-label">{label}</span> : null}
                </div>
              ) : (
                <img src={icon} alt="" width={160} height={160} decoding="async" />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
